module.exports = __webpack_public_path__ + "static/media/fetal-id-education.138411fb.png";